<template>
  <v-dialog
    v-model="visible"
    persistent
    width="840"
  >
    <v-card class="ghd-base-color-black">
      <div class="d-flex pa-6">
        <div>
          <img
            src="/images/logo-oro.png"
            width="70"
          >
        </div>
        <div
          class="ml-auto cursor-pointer"
          @click="$emit('turnoff')"
        >
          <svg
            version="1.1"
            x="0px"
            y="0px"
            width="20"
            height="20"
            viewBox="0 0 219.57 220.6"
            style="enable-background:new 0 0 219.57 220.6;"
            xml:space="preserve"
          >
            <path
              fill="white"
              d="M213.72,9.06L213.72,9.06c3.12,3.12,3.12,8.19,0,11.31L17.85,216.24c-3.12,3.12-8.19,3.12-11.31,0l0,0c-3.12-3.12-3.12-8.19,0-11.31L202.4,9.06C205.53,5.93,210.59,5.93,213.72,9.06z"
            />
            <path
              fill="white"
              d="M213.72,215.79L213.72,215.79c-3.12,3.12-8.19,3.12-11.31,0L6.54,19.92c-3.12-3.12-3.12-8.19,0-11.31l0,0c3.12-3.12,8.19-3.12,11.31,0l195.87,195.87C216.84,207.6,216.84,212.67,213.72,215.79z"
            />
          </svg>
        </div>
      </div>
      <v-card-title
        class="ghd-ITCAvant text-xlarge"
        style="color: white !important;"
      >
        RICHIESTA DI ASSISTENZA <br> COMPLETATA!
      </v-card-title>
      <v-card-text class="ghd-text-white">
        {{ data.subtitle }}
      </v-card-text>
      <div class="d-flex justify-space-around mb-6 pb-8 text-center pr-6 pl-6">
        <div style="flex: 1">
          <div>
            <svg
              width="100"
              height="auto"
              viewBox="0 0 60 60"
              version="1.1"
            ><defs /><g
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            ><g
              id="004---Printer"
              fill="#ffffff"
              fill-rule="nonzero"
            ><path
              id="Shape"
              d="M59.932,23.665 C59.924,23.641 59.92,23.617 59.91,23.594 C59.8680045,23.4964667 59.8106058,23.406317 59.74,23.327 L51.228,13.964 C50.0898233,12.7143877 48.4782588,12.0015245 46.788,12 L42,12 L42,2 C42,0.8954305 41.1045695,6.76353751e-17 40,0 L20,0 C18.8954305,-6.76353751e-17 18,0.8954305 18,2 L18,12 L13.212,12 C11.5217412,12.0015245 9.91017672,12.7143877 8.772,13.964 L0.26,23.327 C0.189394179,23.406317 0.131995527,23.4964667 0.09,23.594 C0.08,23.617 0.076,23.641 0.068,23.665 C0.0350696905,23.7552934 0.0158563363,23.8500119 0.011,23.946 C0.01,23.965 0,23.981 0,24 L0,43 C0.00330737898,46.3123376 2.68766243,48.9966926 6,49 L13,49 L9.4,53.8 C8.94547353,54.4060353 8.87236159,55.2168591 9.21114562,55.8944272 C9.54992965,56.5719952 10.2424559,57 11,57 L16.81,57 L16.732,57.173 C16.4508706,57.7920313 16.5034676,58.5114847 16.8716375,59.0830478 C17.2398075,59.6546109 17.8731224,59.9999972 18.553,60 L41.447,60 C42.1268776,59.9999972 42.7601925,59.6546109 43.1283625,59.0830478 C43.4965324,58.5114847 43.5491294,57.7920313 43.268,57.173 L43.189,57 L49,57 C49.7575441,57 50.4500704,56.5719952 50.7888544,55.8944272 C51.1276384,55.2168591 51.0545265,54.4060353 50.6,53.8 L47,49 L54,49 C57.3123376,48.9966926 59.9966926,46.3123376 60,43 L60,24 C60,23.981 59.99,23.965 59.989,23.946 C59.9841437,23.8500119 59.9649303,23.7552934 59.932,23.665 Z M20,2 L40,2 L40,18 L20,18 L20,2 Z M10.252,15.31 C11.0104682,14.4764039 12.0849882,14.0008562 13.212,14 L18,14 L18,18 L17,18 C16.4477153,18 16,18.4477153 16,19 C16,19.5522847 16.4477153,20 17,20 L43,20 C43.5522847,20 44,19.5522847 44,19 C44,18.4477153 43.5522847,18 43,18 L42,18 L42,14 L46.788,14 C47.9150118,14.0008562 48.9895318,14.4764039 49.748,15.31 L56.739,23 L3.261,23 L10.252,15.31 Z M45,46.334 L43,43.667 L43,42 C43,40.3431458 41.6568542,39 40,39 L20,39 C18.3431458,39 17,40.3431458 17,42 L17,43.667 L15,46.334 L15,39 C15.0044086,35.1358343 18.1358343,32.0044086 22,32 L38,32 C41.8641657,32.0044086 44.9955914,35.1358343 45,39 L45,46.334 Z M41,43 L19,43 L19,42 C19,41.4477153 19.4477153,41 20,41 L40,41 C40.5522847,41 41,41.4477153 41,42 L41,43 Z M18.553,58 L22.644,49 L37.356,49 L41.451,58 L18.553,58 Z M42.28,55 L38.922,47.611 L38.911,47.587 C38.8642853,47.4874278 38.8010596,47.3964775 38.724,47.318 C38.703,47.296 38.679,47.279 38.657,47.259 C38.5913703,47.2010433 38.5184131,47.1519569 38.44,47.113 C38.4104343,47.0973934 38.3800579,47.0833735 38.349,47.071 C38.2378522,47.0266411 38.1196445,47.0025931 38,47 L22,47 C21.8807537,47.0023936 21.7628973,47.0261003 21.652,47.07 C21.6209421,47.0823735 21.5905657,47.0963934 21.561,47.112 C21.4825869,47.1509569 21.4096297,47.2000433 21.344,47.258 C21.322,47.278 21.298,47.295 21.277,47.317 C21.1999404,47.3954775 21.1367147,47.4864278 21.09,47.586 L21.079,47.61 L17.72,55 L11,55 L18.5,45 L41.5,45 L49,55 L42.28,55 Z M58,43 C58,45.209139 56.209139,47 54,47 L47,47 L47,39 C46.993939,34.0319499 42.9680501,30.006061 38,30 L22,30 C17.0319499,30.006061 13.006061,34.0319499 13,39 L13,47 L6,47 C3.790861,47 2,45.209139 2,43 L2,25 L58,25 L58,43 Z"
            /><path
              id="Shape"
              d="M53,34 C54.6568542,34 56,32.6568542 56,31 C56,29.3431458 54.6568542,28 53,28 C51.3431458,28 50,29.3431458 50,31 C50,32.6568542 51.3431458,34 53,34 Z M53,30 C53.5522847,30 54,30.4477153 54,31 C54,31.5522847 53.5522847,32 53,32 C52.4477153,32 52,31.5522847 52,31 C52,30.4477153 52.4477153,30 53,30 Z"
            /><circle
              id="Oval"
              cx="53"
              cy="37"
              r="1"
            /><circle
              id="Oval"
              cx="53"
              cy="40"
              r="1"
            /><circle
              id="Oval"
              cx="53"
              cy="43"
              r="1"
            /><path
              id="Shape"
              d="M26,53 L34,53 C34.5522847,53 35,52.5522847 35,52 C35,51.4477153 34.5522847,51 34,51 L26,51 C25.4477153,51 25,51.4477153 25,52 C25,52.5522847 25.4477153,53 26,53 Z"
            /><path
              id="Shape"
              d="M36,54 L24,54 C23.4477153,54 23,54.4477153 23,55 C23,55.5522847 23.4477153,56 24,56 L36,56 C36.5522847,56 37,55.5522847 37,55 C37,54.4477153 36.5522847,54 36,54 Z"
            /><path
              id="Shape"
              d="M5,30 C5.55228475,30 6,29.5522847 6,29 L6,28 C6,27.4477153 5.55228475,27 5,27 C4.44771525,27 4,27.4477153 4,28 L4,29 C4,29.5522847 4.44771525,30 5,30 Z"
            /><path
              id="Shape"
              d="M5,40 C5.55228475,40 6,39.5522847 6,39 L6,33 C6,32.4477153 5.55228475,32 5,32 C4.44771525,32 4,32.4477153 4,33 L4,39 C4,39.5522847 4.44771525,40 5,40 Z"
            /></g></g></svg>
          </div>
          <div style="color: white;" class="text-sm">
            Stampa il QrCode allegato alla mail  (2 copie)
          </div>
        </div>
        <div style="flex: 1">
          <div>
            <svg
              version="1.1"
              fill
              width="100"
              height="auto"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              xml:space="preserve"
            >
              <g fill="white">
                <g>
                  <path
                    d="M491.729,112.971L259.261,0.745c-2.061-0.994-4.461-0.994-6.521,0L20.271,112.971c-2.592,1.251-4.239,3.876-4.239,6.754
			v272.549c0,2.878,1.647,5.503,4.239,6.754l232.468,112.226c1.03,0.497,2.146,0.746,3.261,0.746s2.23-0.249,3.261-0.746
			l232.468-112.226c2.592-1.251,4.239-3.876,4.239-6.754V119.726C495.968,116.846,494.32,114.223,491.729,112.971z M256,15.828
			l215.217,103.897l-62.387,30.118c-0.395-0.301-0.812-0.579-1.27-0.8L193.805,45.853L256,15.828z M176.867,54.333l214.904,103.746
			l-44.015,21.249L132.941,75.624L176.867,54.333z M396.799,172.307v78.546l-41.113,19.848v-78.546L396.799,172.307z
			 M480.968,387.568L263.5,492.55V236.658l51.873-25.042c3.73-1.801,5.294-6.284,3.493-10.015
			c-1.801-3.729-6.284-5.295-10.015-3.493L256,223.623l-20.796-10.04c-3.731-1.803-8.214-0.237-10.015,3.493
			c-1.801,3.73-0.237,8.214,3.493,10.015l19.818,9.567V492.55L31.032,387.566V131.674l165.6,79.945
			c1.051,0.508,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241c1.801-3.73,0.237-8.214-3.493-10.015l-162.37-78.386
			l74.505-35.968L340.582,192.52c0.033,0.046,0.07,0.087,0.104,0.132v89.999c0,2.581,1.327,4.98,3.513,6.353
			c1.214,0.762,2.599,1.147,3.988,1.147c1.112,0,2.227-0.247,3.26-0.746l56.113-27.089c2.592-1.251,4.239-3.875,4.239-6.754v-90.495
			l69.169-33.392V387.568z"
                  />
                </g>
              </g>
              <g fill="white">
                <g>
                  <path
                    d="M92.926,358.479L58.811,342.01c-3.732-1.803-8.214-0.237-10.015,3.493c-1.801,3.73-0.237,8.214,3.493,10.015
			l34.115,16.469c1.051,0.508,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241
			C98.22,364.763,96.656,360.281,92.926,358.479z"
                  />
                </g>
              </g>
              <g fill="white">
                <g>
                  <path
                    d="M124.323,338.042l-65.465-31.604c-3.731-1.801-8.214-0.237-10.015,3.494c-1.8,3.73-0.236,8.214,3.494,10.015
			l65.465,31.604c1.051,0.507,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241
			C129.617,344.326,128.053,339.842,124.323,338.042z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="text-sm" style="color: white" >
            Inserisci una copia all'interno ed una all'esterno del pacco
          </div>
        </div>

        <div style="flex: 1">
          <div>
            <svg
              version="1.1"
              width="100"
              height="auto"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background:new 0 0 512 512;"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    fill="white"
                    d="M476.158,231.363l-13.259-53.035c3.625-0.77,6.345-3.986,6.345-7.839v-8.551c0-18.566-15.105-33.67-33.67-33.67h-60.392
			V110.63c0-9.136-7.432-16.568-16.568-16.568H50.772c-9.136,0-16.568,7.432-16.568,16.568V256c0,4.427,3.589,8.017,8.017,8.017
			c4.427,0,8.017-3.589,8.017-8.017V110.63c0-0.295,0.239-0.534,0.534-0.534h307.841c0.295,0,0.534,0.239,0.534,0.534v145.372
			c0,4.427,3.589,8.017,8.017,8.017c4.427,0,8.017-3.589,8.017-8.017v-9.088h94.569c0.008,0,0.014,0.002,0.021,0.002
			c0.008,0,0.015-0.001,0.022-0.001c11.637,0.008,21.518,7.646,24.912,18.171h-24.928c-4.427,0-8.017,3.589-8.017,8.017v17.102
			c0,13.851,11.268,25.119,25.119,25.119h9.086v35.273h-20.962c-6.886-19.883-25.787-34.205-47.982-34.205
			s-41.097,14.322-47.982,34.205h-3.86v-60.393c0-4.427-3.589-8.017-8.017-8.017c-4.427,0-8.017,3.589-8.017,8.017v60.391H192.817
			c-6.886-19.883-25.787-34.205-47.982-34.205s-41.097,14.322-47.982,34.205H50.772c-0.295,0-0.534-0.239-0.534-0.534v-17.637
			h34.739c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017H8.017c-4.427,0-8.017,3.589-8.017,8.017
			s3.589,8.017,8.017,8.017h26.188v17.637c0,9.136,7.432,16.568,16.568,16.568h43.304c-0.002,0.178-0.014,0.355-0.014,0.534
			c0,27.996,22.777,50.772,50.772,50.772s50.772-22.776,50.772-50.772c0-0.18-0.012-0.356-0.014-0.534h180.67
			c-0.002,0.178-0.014,0.355-0.014,0.534c0,27.996,22.777,50.772,50.772,50.772c27.995,0,50.772-22.776,50.772-50.772
			c0-0.18-0.012-0.356-0.014-0.534h26.203c4.427,0,8.017-3.589,8.017-8.017v-85.511C512,251.989,496.423,234.448,476.158,231.363z
			 M375.182,144.301h60.392c9.725,0,17.637,7.912,17.637,17.637v0.534h-78.029V144.301z M375.182,230.881v-52.376h71.235
			l13.094,52.376H375.182z M144.835,401.904c-19.155,0-34.739-15.583-34.739-34.739s15.584-34.739,34.739-34.739
			c19.155,0,34.739,15.583,34.739,34.739S163.99,401.904,144.835,401.904z M427.023,401.904c-19.155,0-34.739-15.583-34.739-34.739
			s15.584-34.739,34.739-34.739c19.155,0,34.739,15.583,34.739,34.739S446.178,401.904,427.023,401.904z M495.967,299.29h-9.086
			c-5.01,0-9.086-4.076-9.086-9.086v-9.086h18.171V299.29z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    fill="white"
                    d="M144.835,350.597c-9.136,0-16.568,7.432-16.568,16.568c0,9.136,7.432,16.568,16.568,16.568
			c9.136,0,16.568-7.432,16.568-16.568C161.403,358.029,153.971,350.597,144.835,350.597z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    fill="white"
                    d="M427.023,350.597c-9.136,0-16.568,7.432-16.568,16.568c0,9.136,7.432,16.568,16.568,16.568
			c9.136,0,16.568-7.432,16.568-16.568C443.591,358.029,436.159,350.597,427.023,350.597z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    fill="white"
                    d="M332.96,316.393H213.244c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017H332.96
			c4.427,0,8.017-3.589,8.017-8.017S337.388,316.393,332.96,316.393z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M127.733,282.188H25.119c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h102.614
			c4.427,0,8.017-3.589,8.017-8.017S132.16,282.188,127.733,282.188z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M278.771,173.37c-3.13-3.13-8.207-3.13-11.337,0.001l-71.292,71.291l-37.087-37.087c-3.131-3.131-8.207-3.131-11.337,0
			c-3.131,3.131-3.131,8.206,0,11.337l42.756,42.756c1.565,1.566,3.617,2.348,5.668,2.348s4.104-0.782,5.668-2.348l76.96-76.96
			C281.901,181.576,281.901,176.501,278.771,173.37z"
                  />
                </g>
              </g>

            </svg>
          </div>
          <div class="text-sm" style="color: white">
            {{ data.courierText }}
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>

// import { ref } from '@vue/composition-api'

export default {
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    data: {
      required: true,
      type: [Object, Array],
    },

    // data: {
    //   required: true,
    //   type: [Object, Array],
    // },
  },
  setup() {
    // const isDialogCompleteAssVisible = ref(true)
    //
    // return {
    //   isDialogCompleteAssVisible,
    // }
  },
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth.scss';
</style>
